import { OrganizationKeyName } from "../../../model/Organization";
import { HomepageConfigListItem } from "../model/HomepageConfigListSuccessResponse";

export const GET_HOMEPAGE_LIST_SUCCESS = "SHOP:GET_HOMEPAGE_LIST_SUCCESS";

export const getHomepageListSuccessAction = (
  organization: OrganizationKeyName,
  data: HomepageConfigListItem[]
) => ({
  type: GET_HOMEPAGE_LIST_SUCCESS as typeof GET_HOMEPAGE_LIST_SUCCESS,
  organization,
  data,
});

export type GetHomepageListSuccessAction = ReturnType<
  typeof getHomepageListSuccessAction
>;
